<div class="session-plan-area col-sm-12 h-100 p-2" role="document">

  <div class="h-100 bg-white">
    <div class="header" (dblclick)="expandNotes()">
      <!-- <button type="button" (click)="createActivity('XX');" class="close menuItemsClrBlack"
        aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button> -->
      <span class="myNoteSwitchLayoutBtn cursorPointer" (click)="switchNoteLayout(showLargeTextarea)">
        <fa-icon *ngIf="showLargeTextarea == true" (click)="createActivity('Nt')"
          class="fas margintop7pxminus menuItemsClrBlack" [icon]="faExchangeAlt">
        </fa-icon>
        <fa-icon *ngIf="showLargeTextarea == false" (click)="createActivity('Snt')"
          class="fas margintop7pxminus menuItemsClrBlack" [icon]="faExchangeAlt">
        </fa-icon>
      </span>
      <h5 *ngIf="showLargeTextarea == true" class="modal-title cursorArrow">
        {{ 'myNotes.myNotesHeading' | translate }}
      </h5>
      <h5 *ngIf="showLargeTextarea == false" class="modal-title cursorArrow">
        {{ 'myNotes.projectNotesHeading' | translate }}
      </h5>
    </div>
    <div class="body mynotes-modal-body-height">
      <div class="row h-100 bg-black" *ngIf="!showLargeTextarea">
        <div class="row strict card bg-white h-100">
          <div class="row strict">
            <div class="col-xs-12 btn-padding space-separable noPaddingLeft">
              <div class="row strict radio-button">
                <div class="dropdown">
                  <button class="btn btn-default btn-sm btn-block dropdown-toggle" type="button" data-toggle="dropdown">
                    <div class="row strict">
                      <div class="col-xs-10">
                        <span *ngIf="selectedModule!=''">
                          {{selectedModule.mName}}
                        </span>
                        <span *ngIf="selectedModule==''">
                          Choose module
                        </span>
                      </div>
                      <div class="col-xs-1 col-xs-offset-1 pull-right ">
                        <span class="caret"></span>
                      </div>
                    </div>
                  </button>
                  <ul class="dropdown-menu myNoteEntityDropdown">
                    <li class="row strict" *ngFor="let eut of modelData.modules; let tabIndex = index">
                      <div class="col-xs-11 col-xs-offset-1   dropdown-item cursorPointer" (click)="selectModule(eut)">
                        {{eut.mName}}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="row strict">
            <div class="col-sm-12 col-xs-12 btn-padding space-separable noPaddingLeft">
              <div class="dropdown">
                <button class="btn btn-default btn-sm span-button btn-block dropdown-toggle" type="button"
                  data-toggle="dropdown">
                  <div class="row strict" *ngIf="entityExists(eutTypes[index])">
                    <div class="col-xs-10 span-on-button text-flow ">
                      {{entityName||'myNotes.chooseEntityButton' | translate }}
                    </div>
                    <div class="col-xs-1 col-xs-offset-1 pull-right ">
                      <span class="caret"></span>
                    </div>
                  </div>
                  <div class="row strict" *ngIf="!entityExists(eutTypes[index])">
                    <div class="col-xs-11 span-on-button text-flow ">
                      {{ 'myNotes.chooseEntityButton' | translate }}
                    </div>
                    <div class="col-xs-1 pull-right ">
                      &nbsp;
                    </div>
                  </div>
                </button>
                <ul class="dropdown-menu fit-size">
                  <li *ngIf="!entityExists(eutTypes[index])">
                    <div class="alert alert-warning">
                    </div>
                  </li>
                  <li
                    *ngFor="let eut of modelData.listOfEUTs|moduleEntityListFilter:selectedModule:filterTypeList:searchText; let tabIndex = index"
                    [ngClass]="{displayNone:!entityExists(eutTypes[index])}" (click)="selectEntity(eut)">
                    <a class="dropdown-item">{{eut.eName}}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="row strict h-90 card bg-white borderWhite">
            <div id="executorQuillCSS" class="test-designer-quill-content-height">
              <quill-editor (onEditorChanged)="editorChangedNotes($event)" (onBlur)="blur($event)"
                [(ngModel)]="selectedEntityNotes.notes">
                <div quill-editor-toolbar>
                  <span class="ql-formats">
                    <select class="ql-header"></select>
                    <button class="ql-bold" [title]="'Bold'"></button>
                    <button class="ql-italic" [title]="'Italic'"></button>
                    <button class="ql-underline" [title]="'Underline'"></button>
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <!-- <button class="ql-image" [title]="'Image'"></button>
                    <button class="ql-code" [title]="'Code'"></button> -->
                  </span>
                </div>
              </quill-editor>
            </div>
          </div>
        </div>
      </div>

      <div class="row h-96 bg-black" *ngIf="showLargeTextarea">
        <div class="row strict h-100 w-100">
          <div class="note-input-area h-100 editor-background">
            <div id="mynoteQuillCSS" class="h-100">
              <quill-editor (onEditorChanged)="editorChanged($event)" [(ngModel)]="notesEditorContent">
                <div quill-editor-toolbar>
                  <span class="ql-formats">
                    <select class="ql-header"></select>
                    <button class="ql-bold" [title]="'Bold'"></button>
                    <button class="ql-italic" [title]="'Italic'"></button>
                    <button class="ql-underline" [title]="'Underline'"></button>
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <!-- <button class="ql-image" [title]="'Image'"></button>
                    <button class="ql-code" [title]="'Code'"></button> -->
                  </span>
                </div>
              </quill-editor>
            </div>
            <div class="fixedToBottom">
              <!-- add button dropdown section -->
              <div class="row full-width">
                <div class="col-sm-2 col-xs-2">
                  <div class="form-group">
                    <div class="col-12 pl-0 pr-0">
                      <div class="dropup">
                        <button type="button"
                          class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <div class="row strict">
                            <div class="col-xs-10 span-on-button">
                              <span>{{selectedAddtype.name}}</span>
                            </div>
                            <div class="col-xs-1 col-xs-offset-1 pull-right ">
                              <span class="caret"></span>
                            </div>
                          </div>
                        </button>

                        <ul class="dropdown-menu testDesignerEntityDropdown">
                          <li class="row strict" *ngFor="let Attr of dropUpMenuItems">
                            <div class="col-xs-11 col-xs-offset-1  dropdown-item cursorPointer"
                              (click)="updateAddType(Attr.value)">
                              {{Attr.name}}
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-1 col-xs-1">
                  <button type="button" (click)="checkQuillSelection()"
                    class="btn btn-default btn-block btn-sm float-right paddingtop3px paddingbottom3px">
                    <fa-icon class="fas icon-black" [icon]="faPlus"></fa-icon>
                  </button>
                </div>
                <div class="col-sm-9 col-xs-9"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>